export const parseXmlSource = (xmlData: string) => {
    return new Promise<{loginUrl: string, certificate: string}>((resolve, reject) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlData, 'text/xml');

        const getKeyDescriptor = (tag: string) => xmlDoc.getElementsByTagName(tag)[0];
        const getSingleSignOnService = (tag: string) => xmlDoc.getElementsByTagName(tag);

        try {
            const keyDescriptor = getKeyDescriptor('md:KeyDescriptor') || getKeyDescriptor('KeyDescriptor');
            const certificate = keyDescriptor?.getElementsByTagName('ds:X509Certificate')[0]?.textContent ||
                keyDescriptor?.getElementsByTagName('X509Certificate')[0]?.textContent || '';

            if (!certificate) {
                return reject(new Error(
                    'Certificate not found in the XML file. Please make sure the file is in the correct format.',
                ));
            }

            let singleSignOnServices = getSingleSignOnService('md:SingleSignOnService');
            if (!singleSignOnServices.length) {
                singleSignOnServices = getSingleSignOnService('SingleSignOnService');
            }
            const loginUrl = Array.from(singleSignOnServices)
                .find(service => service.getAttribute('Binding')
                    ?.includes('HTTP-Redirect'))?.getAttribute('Location') ||
                    Array.from(singleSignOnServices)
                        .find(service => service.getAttribute('Binding')
                            ?.includes('HTTP-POST'))?.getAttribute('Location') || '';

            if (!loginUrl) {
                return reject(new Error(
                    'Login URL not found in the XML file. Please make sure the file is in the correct format.',
                ));
            }

            return resolve({loginUrl, certificate});
        } catch (e) {
            if (e) {
                return reject(new Error(
                    'Cannot parse the XML file. Please make sure the file is in the correct format.',
                ));
            }
        }
    });
};
